module.exports = __webpack_public_path__ + "static/img/6.783e231.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/1/eng/6.png
// module id = XKWW
// module chunks = 0